/**
 * @generated SignedSource<<f2317619387927398c8bcf7ba8bafa07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AdMetricFilterField = "AmountSpent" | "CostPerPurchase" | "CostPerWebsitePurchase" | "Impressions" | "LandingPageViews" | "Leads" | "LinkClicks" | "Purchases" | "Rate" | "WebsiteAddToCarts" | "WebsiteLeads" | "WebsitePurchases" | "%future added value";
export type ContentType = "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type CurrencyType = "CAD" | "EUR" | "USD" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type ListPerformanceSummarizedMetaAdsOrderBy = "KPI_ASC" | "KPI_DESC" | "%future added value";
export type MetricFilterOperator = "EQ" | "GT" | "GTE" | "LT" | "LTE" | "NE" | "%future added value";
export type ListPerformanceSummarizedMetaAdsRequest = {
  config: ListPerformanceSummarizedMetaAdsConfig;
  filter: ListPerformanceSummarizedMetaAdsFilter;
  orderBy?: ListPerformanceSummarizedMetaAdsOrderBy | null;
  pagination?: PaginationInput | null;
};
export type ListPerformanceSummarizedMetaAdsFilter = {
  brandId?: string | null;
  contentTypes?: ReadonlyArray<ContentType> | null;
  deduplicateAdNames?: boolean | null;
  filterOutZero?: boolean | null;
  metrics?: ReadonlyArray<AdMetricFilter> | null;
  performanceDateRange?: DateRangeInput | null;
  searchQueries?: ReadonlyArray<SearchQuery> | null;
};
export type DateRangeInput = {
  end: string;
  start: string;
};
export type SearchQuery = {
  fieldKey: string;
  type: string;
  value: string;
};
export type AdMetricFilter = {
  fieldKey: AdMetricFilterField;
  operator: MetricFilterOperator;
  value: number;
};
export type ListPerformanceSummarizedMetaAdsConfig = {
  kpi: KPI;
  scrubSensitiveData?: boolean | null;
};
export type PaginationInput = {
  skip?: number | null;
  take?: number | null;
};
export type AdPerformanceTableQuery$variables = {
  input: ListPerformanceSummarizedMetaAdsRequest;
  skip: boolean;
};
export type AdPerformanceTableQuery$data = {
  readonly listPerformanceSummarizedMetaAds?: {
    readonly count: number;
    readonly data: ReadonlyArray<{
      readonly amountSpent: any | null;
      readonly brandId: string | null;
      readonly costPerPurchase: number | null;
      readonly costPerWebsitePurchase: number | null;
      readonly externalId: string | null;
      readonly id: string;
      readonly impressions: any | null;
      readonly landingPageViews: any | null;
      readonly name: string | null;
      readonly primaryText: string | null;
      readonly purchases: number | null;
      readonly rate: string | null;
      readonly reach: any | null;
      readonly tags: ReadonlyArray<string> | null;
      readonly websiteAddToCarts: any | null;
      readonly websitePurchases: any | null;
    }>;
    readonly metadata: {
      readonly currencyType: CurrencyType | null;
    };
    readonly pageInfo: {
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
  };
};
export type AdPerformanceTableQuery = {
  response: AdPerformanceTableQuery$data;
  variables: AdPerformanceTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "PerformanceSummarizedMetaAdList",
        "kind": "LinkedField",
        "name": "listPerformanceSummarizedMetaAds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PerformanceSummarizedMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PerformanceSummarizedMetaAd",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amountSpent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "impressions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "landingPageViews",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "websitePurchases",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "websiteAddToCarts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costPerPurchase",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reach",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tags",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "costPerWebsitePurchase",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "purchases",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brandId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdPerformanceTableQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdPerformanceTableQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "96b759a70b4bec213507c50bbb129e4a",
    "id": null,
    "metadata": {},
    "name": "AdPerformanceTableQuery",
    "operationKind": "query",
    "text": "query AdPerformanceTableQuery(\n  $input: ListPerformanceSummarizedMetaAdsRequest!\n  $skip: Boolean!\n) {\n  listPerformanceSummarizedMetaAds(input: $input) @skip(if: $skip) {\n    count\n    metadata {\n      currencyType\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    data {\n      id\n      amountSpent\n      externalId\n      name\n      primaryText\n      rate\n      impressions\n      landingPageViews\n      websitePurchases\n      websiteAddToCarts\n      costPerPurchase\n      reach\n      tags\n      costPerWebsitePurchase\n      purchases\n      brandId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff1f2cb8069b4c2155b34b3fe09fbff4";

export default node;
